import { render, staticRenderFns } from "./GobIcon.vue?vue&type=template&id=3b7feeef&"
import script from "./GobIcon.vue?vue&type=script&lang=js&"
export * from "./GobIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports